import { defineMessages } from 'react-intl';

export const scope = 'app.components.HomeValuation';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'What{rsquo}s your home worth?',
  },
  headerOneForMobile: {
    id: `${scope}.headerOneForMobile`,
    defaultMessage: 'See what{rsquo}s your home worth',
  },
  headerTwoForMobile: {
    id: `${scope}.headerTwoForMobile`,
    defaultMessage:
      'You{rsquo}re Just One Step Away From Your Free Home Valuation',
  },
  submitButton: {
    id: `${scope}.submitButton`,
    defaultMessage: 'Get My Home Value Report',
  },
  disclaimer: {
    id: `${scope}.disclaimer`,
    defaultMessage:
      'By submitting your information, you consent and agree that Richr and its affiliates may use automated technology, including pre-recorded messages, cell phones, and texts, and email to contact you at the number and email address you provided. This includes if your number is currently on any Do Not Call Lists. Consent is not required to make a purchase. Message and data rates may apply. You also agree to Our Terms of Service.',
  },
  formHeader: {
    id: `${scope}.formHeader`,
    defaultMessage:
      'Don{rsquo}t sell for less. Complete the form and get your [free] home value estimate instantly',
  },
  viewMoreDetails: {
    id: `${scope}.viewMoreDetails`,
    defaultMessage: 'View more details',
  },
  backCTA: {
    id: `${scope}.backCTA`,
    defaultMessage: 'Back',
  },
  editCTA: {
    id: `${scope}.editCTA`,
    defaultMessage: 'Edit',
  },
  estimationHeading: {
    id: `${scope}.estimationHeading`,
    defaultMessage: 'Your estimated home value is',
  },
  estimationNote: {
    id: `${scope}.estimationNote`,
    defaultMessage:
      'This is our estimate of your home value and is intended to be used for illustrative purposes only and does not represent a confirmation of actual home value.',
  },
  tenXNote: {
    id: `${scope}.tenXNote`,
    defaultMessage:
      'Make 10X more money when you sell your home, Sell your home for only a 1% fee, and earn 4.58% interest on your home sale proceeds',
  },
  startListingCTA: {
    id: `${scope}.startListingCTA`,
    defaultMessage: 'Start listing now',
  },
  chatBotNote: {
    id: `${scope}.chatBotNote`,
    defaultMessage:
      'Having questions? Talk to our chatbot to get answers to you most pressing questions, or to access our assistance.',
  },
  showMoreCTA: {
    id: `${scope}.showMoreCTA`,
    defaultMessage: 'Show More',
  },
  showLessCTA: {
    id: `${scope}.showLessCTA`,
    defaultMessage: 'Show Less',
  },
  chartHeading: {
    id: `${scope}.chartHeading`,
    defaultMessage: 'Estimated Value Over Time',
  },
  cmaHeading: {
    id: `${scope}.cmaHeading`,
    defaultMessage: 'Want A Comparative Market Analysis? ',
  },
  cmaDescription: {
    id: `${scope}.cmaDescription`,
    defaultMessage:
      'Get a free market analysis with detailed information of home sales similar to your home to find out how you can get the most out of your home sale.',
  },
  cmaCTA: {
    id: `${scope}.cmaCTA`,
    defaultMessage: 'Get a free CMA report',
  },
  addressErrorTitle: {
    id: `${scope}.addressErrorTitle`,
    defaultMessage: 'Oops!',
  },
  addressErrorSubtitle: {
    id: `${scope}.addressErrorSubtitle`,
    defaultMessage: 'Seems like we couldn’t get an estimate for this address.',
  },
  addressErrorDescription: {
    id: `${scope}.addressErrorDescription`,
    defaultMessage:
      'Fear not! You can request a callback and an expert from our team will assist you as soon as possible. In the meantime you can interact with our chatbot to assist you with your questions.',
  },
  addressErrorCTA: {
    id: `${scope}.addressErrorCTA`,
    defaultMessage: 'Get a callback',
  },
  requestSent: {
    id: `${scope}.requestSent`,
    defaultMessage: 'Request Sent',
  },
});
